import {
  Card,
  Grid,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { moneyFormat } from 'design-system';
// Data models
import { faCar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QuotationSummaryResponse } from 'data-layer-cr/dist/models';
import DescriptionItem from './DescriptionItem';

const { formatMoney } = moneyFormat;

const useStyles = makeStyles(() => ({
  titleSection: { paddingBottom: 7, marginBottom: 20 },
  logo: { marginRight: 11 },
  titleText: {
    fontSize: 19,
    fontWeight: 900,
  },
  cardRoot: {
    height: 'fit-content',
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 25,
    paddingRight: 20,
    borderRadius: 10,
    boxShadow: '0px 2px 15px rgba(0, 0, 0, 0.08)',
    maxWidth: ({ isMobile }: { isMobile: boolean }) =>
      isMobile ? '100%' : '500px',
    width: '100%',
  },
  block: {
    marginTop: 20,
  },
  sumaText: {
    fontSize: 17,
    fontWeight: 900,
  },
  titleTextCar: {
    fontSize: 15,
    fontWeight: 400,
    color: '#4A4B4E',
  },
}));

type Props = {
  quotationSummary: QuotationSummaryResponse;
};

const VehicleResumeCard = ({ quotationSummary }: Props): JSX.Element => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles({ isMobile });
  const { carBrand, carModel, carYear, insuranceValue, profile } =
    quotationSummary;
  return (
    <Card className={classes.cardRoot} data-testid="vehicle-resume-card">
      <Grid container className={classes.titleSection}>
        <FontAwesomeIcon
          icon={faCar}
          size="2x"
          color="#0D2E68"
          style={{ marginRight: 10 }}
        />
        <Typography className={classes.titleText} data-testid="title-text">
          Datos del auto
        </Typography>
      </Grid>
      <Grid container>
        <Typography className={classes.titleTextCar} data-testid="title-text">
          {`${carBrand} ${carModel}`}
        </Typography>
      </Grid>
      <DescriptionItem
        data-testid="year-description"
        description="Año"
        value={carYear}
      />
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        className={classes.block}
      >
        <Typography className={classes.sumaText}>Suma asegurada</Typography>

        <Typography
          data-testid="ensurance-cost-description"
          className={classes.titleText}
        >
          {formatMoney(insuranceValue, false, profile.typeOfMoney)}
        </Typography>
      </Grid>
    </Card>
  );
};

export default VehicleResumeCard;
